import React, {PropTypes} from 'react';
import {Col, Row} from 'react-bootstrap/lib/';
import FormInput from './forminput.react';

export const stringToFields = (value, placeholder) => {
  const str = value || '';
  const items = str.split('|')
    .map((value, index) => {
      while (value.charAt(0) === ' ') {
        value = value.substring(1);
      }
      return {value, index};
    });

  return items;
};

export const fieldsToString = (list) => {
  return list
    .map((field) => field.value)
    .join('|');
};

export class MultiFieldsInput extends FormInput {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    maxCharacters: PropTypes.number
  }

  onFieldChanged(event) {
    const {name, value, actions: {updateFieldList}} = this.props;
    const {target: {value: fieldValue, dataset: {fieldIndex}}} = event;
    const fields = stringToFields(value);
    fields[fieldIndex].value = fieldValue;
    const stringValue = fieldsToString(fields);
    updateFieldList({name, value: stringValue});
  }

  onAddMoreClick(event) {
    const {name, actions: {addFieldToList}} = this.props;
    addFieldToList(name);
  }

  render() {
    const {placeholder, title, value, maxCharacters} = this.props;
    const fields = stringToFields(value, title);
    return (
      <Col xs={12}>
        <Row>
          <h3>{title}</h3>
          {fields.map(({value, index}) => {
            return (
              <div className="form-group" key={index}>
                <input
                  className="form-control"
                  type="text"
                  placeholder={placeholder}
                  data-field-index={index}
                  value={value}
                  maxLength={maxCharacters}
                  onChange={::this.onFieldChanged}
                />
              </div>
            );
          })}
          <a onClick={::this.onAddMoreClick}>Add more</a>
        </Row>
      </Col>
    );
  }
}
